import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { ChangeStatusRequest } from '../../source-articles/models/source-article.model';
import { ApiResponse } from '../../../shared/models/api-response.model';
import {
  CreateSourceArticleCharacteristicRequest,
  SourceArticleCharacteristic,
  UpdateSourceArticleCharacteristicRequest
} from '../models/source-article-characteristic.model';

@Injectable({
  providedIn: 'root'
})
export class SourceArticleCharacteristicsService {
  private readonly http = inject(HttpClient);
  private readonly sourceArticlesUrl = `${environment.apiUrl}/api/fuentes-articulos`;
  private readonly baseUrl = `${environment.apiUrl}/api/fuentes-articulos-caracteristicas`;

  getBySourceArticle(pkSourceArticle: number): Observable<ApiResponse<SourceArticleCharacteristic[]>> {
    return this.http.get<ApiResponse<SourceArticleCharacteristic[]>>(
      `${this.sourceArticlesUrl}/${pkSourceArticle}/caracteristicas`
    );
  }

  getById(id: number): Observable<ApiResponse<SourceArticleCharacteristic>> {
    return this.http.get<ApiResponse<SourceArticleCharacteristic>>(`${this.baseUrl}/${id}`);
  }

  create(
    pkSourceArticle: number,
    request: CreateSourceArticleCharacteristicRequest
  ): Observable<ApiResponse<SourceArticleCharacteristic>> {
    return this.http.post<ApiResponse<SourceArticleCharacteristic>>(
      `${this.sourceArticlesUrl}/${pkSourceArticle}/caracteristicas`,
      request
    );
  }

  update(
    id: number,
    request: UpdateSourceArticleCharacteristicRequest
  ): Observable<ApiResponse<SourceArticleCharacteristic>> {
    return this.http.put<ApiResponse<SourceArticleCharacteristic>>(`${this.baseUrl}/${id}`, request);
  }

  changeStatus(
    id: number,
    request: ChangeStatusRequest
  ): Observable<ApiResponse<SourceArticleCharacteristic>> {
    return this.http.patch<ApiResponse<SourceArticleCharacteristic>>(`${this.baseUrl}/${id}/estado`, request);
  }
}
